import React from "react";
import { Row, Col } from "react-bootstrap";

import { FORM_FIELD_KEYS } from "../../../../constants/forms";
import { getFieldProps } from "../../../../utils/form-fields";

import TextInput from "../../../controls/TextInput";
import MaskInput from "../../../controls/MaskInput";

function CommunicationBlock({ values = {}, onChange }) {
  return (
    <Row>
      <Col xs={12}>
        <div className="inputs-block-title">
          <span>Communication</span>
        </div>
      </Col>
      <Col xs={12}>
        <MaskInput
          {...getFieldProps(FORM_FIELD_KEYS.customerPhone)}
          value={values[FORM_FIELD_KEYS.customerPhone]}
          onChange={onChange}
        />
      </Col>
      <Col xs={12}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.customerEmail)}
          hint={(
            <>
              <strong>Recipient E-mail</strong>
              <br />
              <strong>IMPORTANT:</strong> This is the e-mail where we will send the EIN Number, once processed. Make sure
              it is an e-mail that is checked frequently, and can receive incoming messages.
            </>
          )}
          loading={values.verifying}
          value={values[FORM_FIELD_KEYS.customerEmail]}
          onChange={onChange}
        />
      </Col>
      <Col xs={12}>
        <div className="inputs-block-divider" />
      </Col>
    </Row>
  );
}

export default CommunicationBlock;
